module.exports = __webpack_public_path__ + "static/packaging-mobile-89a3d691a59662f771a60011c6a907ad.svg";